import { gql } from '@apollo/client';

const ADMIN_CONSOLE_VOLUNTEER_TAG_FRAGMENT = gql`
  fragment AdminConsoleVolunteerTag on VOLUNTEER_VolunteerTagType {
    volunteerTagId
    name
    description
    colour
    tagGroup
    isArchived
    volunteerCount
  }
`;

export const ADMIN_CONSOLE_VOLUNTEER_TAG_QUERY = gql`
  query GetAdminConsoleVolunteerTags($includeArchived: Boolean) {
    vm {
      volunteerTags(includeArchived: $includeArchived) {
        ...AdminConsoleVolunteerTag
      }
    }
  }
  ${ADMIN_CONSOLE_VOLUNTEER_TAG_FRAGMENT}
`;
